import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "select-group" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "select-group" }
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["disabled"]

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useChartVisibility } from '@/composables/useChartVisibility';
import { SENSOR_LABELS, SENSOR_LIST, CROSS_LIST } from '@/config/chartConfig';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickChartPickerModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

// Lock body scroll
onMounted(() => {
  document.body.style.overflow = 'hidden';
});

onBeforeUnmount(() => {
  document.body.style.overflow = '';
});

const { preferences, setTemporaryChart } = useChartVisibility();

const selectedSensor = ref("");
const selectedCross = ref("");

// Show all sensors/charts, or maybe filter out those already visible?
// "Possibilità di selezionare rapidamente un grafico che non è tra i preferiti"
// implies we should primarily target those NOT in orderedCharts. 
// But being able to jump to one already there is also fine. 
// Let's filter to make it easier to find missing ones, as per implicit goal.
const availableSensors = computed(() => {
  return SENSOR_LIST.filter(s => !preferences.value.orderedCharts.includes(s));
});

const availableCross = computed(() => {
  return CROSS_LIST.filter(c => !preferences.value.orderedCharts.includes(c.id));
});

const confirm = (id: string) => {
  if (!id) return;
  setTemporaryChart(id);
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "modal-overlay",
      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", {
        class: "modal-container",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Visualizzazione Rapida", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            title: "Chiudi"
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "modal-description" }, " Seleziona un grafico per visualizzarlo temporaneamente in cima alla lista. ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Grafico Singolo", -1)),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSensor).value = $event)),
                class: "custom-select"
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, "Seleziona sensore...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSensors.value, (s) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: s,
                    value: s
                  }, _toDisplayString(_unref(SENSOR_LABELS)[s] || s), 9, _hoisted_5))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedSensor.value]
              ]),
              _createElementVNode("button", {
                class: "btn-action",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (confirm(selectedSensor.value))),
                disabled: !selectedSensor.value
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faEye) }, null, 8, ["icon"])
              ], 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Grafico Combinato", -1)),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCross).value = $event)),
                class: "custom-select"
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Seleziona combinato...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCross.value, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.id,
                    value: c.id
                  }, _toDisplayString(c.title), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedCross.value]
              ]),
              _createElementVNode("button", {
                class: "btn-action",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (confirm(selectedCross.value))),
                disabled: !selectedCross.value
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faEye) }, null, 8, ["icon"])
              ], 8, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})